var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      class: _vm.className,
      style: "width:" + _vm.width,
      attrs: {
        icon: _vm.icon,
        disabled: _vm.disabled,
        type: _vm.type,
        size: _vm.size,
        loading: _vm.loading,
      },
      on: { click: _vm.clickHandle },
    },
    [_vm._t("default"), _vm._v("\n  " + _vm._s(_vm.label) + "\n")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }